import React from 'react';

import { FormStatus, SelectionMode, EntryListingMode, WorkflowStep } from 'model/dictionary';

import EntriesPage from 'components/EntriesPage';

export default function Finalists() {

	return (
		<EntriesPage
			title="Finalistas"
			description="Acá se eligen los finalistas de cada premio a partir de la preselección. Elija un premio para ver sus postulaciones confirmadas ordenadas por el puntaje que les dieron los seleccionadores, con la cantidad de valoraciones, el total y el promedio. Marque las que pasan a la votación y presione Confirmar: quedan como finalistas y el jurado las ve en Votación."
			workflowStep={WorkflowStep.FINALISTS}
			entryListMode={EntryListingMode.FINALISTS}
			formStatusFiltered={FormStatus.CONFIRMED}
			formStatusConfirmed={FormStatus.FINALIST}
			selectionMode={SelectionMode.MULTIPLE}
		/>
	);

}
